import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddStockItem$Params } from 'src/api/generated/fn/inventory/add-stock-item';
import { GetStockItem$Params } from 'src/api/generated/fn/inventory/get-stock-item';
import { UpdateStockItem$Params } from 'src/api/generated/fn/inventory/update-stock-item';
import { EnumTypeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/EnumTypes/enum-type-dto';
import { StockItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-item-dto';
import { InventoryService } from 'src/api/generated/services';

@Component({
  selector: 'app-add-or-edit-inventory-item',
  templateUrl: './add-or-edit-inventory-item.component.html',
  styleUrls: ['./add-or-edit-inventory-item.component.scss']
})
export class AddOrEditInventoryItemComponent implements OnInit {

  inventoryItem: StockItemDto = {} as StockItemDto;
  measurementUnits: Array<EnumTypeDto>;
  editFlag: boolean = false;

  constructor(private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              private inventoryService: InventoryService) {
    
    if (this.config.data != undefined && this.config.data.id) {
        this.editFlag = true;
        const params: GetStockItem$Params = { stockItemId: this.config.data.id };
        this.inventoryService.getStockItem(params).subscribe(response => this.inventoryItem = response );
    }  
}
  ngOnInit(): void {
    this.inventoryService.getMeasurementUnitTypes().subscribe(response => this.measurementUnits = response.unitTypes ? response.unitTypes : [] );
  }
  
  save(f: NgForm) {
    if(f.valid){
      if (this.editFlag){
        if(this.inventoryItem.id){
          const params: UpdateStockItem$Params = { stockItemId: this.inventoryItem.id, body: this.inventoryItem };
          this.inventoryService.updateStockItem(params).subscribe({ 
            next: response => this.ref.close(true), 
            error: errorResponse => this.ref.close(errorResponse)
          });
        }
      }else {
        const params: AddStockItem$Params = { body: this.inventoryItem };
        this.inventoryService.addStockItem(params).subscribe({ 
          next: response => this.ref.close(true), 
          error: errorResponse => this.ref.close(errorResponse)
        });
      }
    }
  }

  close(){
    this.ref.close(false);
  }

}
